'use client'

import { useHomeStore } from "@/context/homePageStore";
import { useStateStore } from "@/context/stateStore";
import { Menu } from "@mantine/core";
import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { TabItem } from "../wrappers/navWrapper";

// interface TargetButtonProps extends React.ComponentPropsWithoutRef<'button'> {
//     opened: boolean;
//     textCSS: string;
//     currTabLabel: string;
//     handleClick: () => void;
// }

// const TargetButton = forwardRef<HTMLButtonElement, TargetButtonProps>(
//     ({ opened, textCSS, currTabLabel, handleClick }: TargetButtonProps, ref) => (
//         <UnstyledButton
//             ref={ref}

//         </UnstyledButton >
//     ));

export default function PageSpecificTabs({ currTab, editList, tabs, specificObjectName }: { currTab: number, editList: boolean, tabs: TabItem[], specificObjectName: string }) {

    const [opened, setOpened] = useState(false);
    const setSpecificTab = useStateStore((state) => state.setSpecificTab);
    const setOverlay = useStateStore((state) => state.setOverlay);
    const setListEdit = useHomeStore((state) => state.setEditList);
    

    const buttonCSS = `w-content truncate flex flex-row justify-evenly items-center space-x-2 truncate transition-all duration-100 ease-in-out rounded-md border border-gray-200`;
    const textCSS = `text-[12px] sm:text-[14px] md:text-[16px] truncate h-content w-full p-1`;

    const handleClick = () => {
        setOpened(!opened);
    }

    const handleItemClick = (index: number) => {
        setOverlay(false);
        setSpecificTab(index);
        setListEdit(false);
        setOpened(false);
    }

    //widthQuery < 640 ? 300 : 400
    // (commented out for now, can be used for dynamic width)

    return (

        <section className={`flex flex-row justify-end items-center max-w-1/2 w-full ${editList ? 'pl-1' : ''} h-fit pr-2 sm:pr-4`}>
            <Menu shadow="md" width={'auto'} closeOnClickOutside={true} opened={opened} closeOnItemClick={true} onChange={setOpened} transitionProps={{
                transition: 'fade-down',
                duration: 200,
                timingFunction: 'ease',
            }} onClose={() => setOverlay(false)} onOpen={() => setOverlay(true)}>

                <Menu.Target>

                        <div className="flex flex-row justify-center items-center h-content w-auto">
                            <button className={`flex flex-row justify-end items-center cursor-pointer bg-gray-100 border border-gray-200 hover:underline text-black hover:text-gray-700 w-auto h-full px-2 py-1 space-x-2 truncate rounded-md`} onClick={handleClick}
                            >
                                <span className={`text-[12px] sm:text-[14px] md:text-[16px] truncate h-content w-full`}>{tabs[currTab] ? tabs[currTab].label : 'Err tab'}</span>
                                <FaChevronDown className={`transform ${opened ? 'rotate-180' : 'rotate-0'} transition-transform duration-200`} />
                            </button>
                        </div>

                </Menu.Target>

                <Menu.Dropdown>

                    <Menu.Label>
                        <p className="text-md md:text-lg underline truncate">{specificObjectName}</p>
                    </Menu.Label>

                    {tabs.map((tab, index) => (
                        <Menu.Item key={index} leftSection={tab.icon} onClick={() => handleItemClick(index)} className={`${buttonCSS} ${currTab === index ? 'no-cursor bg-yellow-100 text-black' : 'bg-green-400 cursor-pointer hover:underline hover:bg-blue-200 text-black'} w-full h-full`} disabled={currTab === index}>
                            <p className={`${textCSS} ${currTab === index ? 'underline' : ''}`}>
                                {tab.label}
                            </p>
                        </Menu.Item>
                    ))}

                </Menu.Dropdown>
            </Menu>
        </section>

    )
}
